import { memo, useMemo } from 'react';
import { Skeleton, Box } from '@mui/material';
import { IArgumentMetadata } from '@tymely/atoms';
import { TreeView, TreeNode } from '@tymely/components';

export const ArgParams = memo(
    (props: { loading?: boolean; argNames?: string[]; argsMetadata?: Record<string, IArgumentMetadata> }) => {
        const tree = useMemo(
            () =>
                (props.argNames || [])
                    .map<TreeNode | null>((argName) => {
                        const arg = props.argsMetadata?.[argName];
                        return arg
                            ? {
                                  id: argName,
                                  name: (
                                      <>
                                          <Box component="span" fontWeight={500}>
                                              {argName}
                                          </Box>
                                          : {arg.dtype.toLowerCase()}
                                      </>
                                  ),
                              }
                            : null;
                    })
                    .filter(Boolean),
            [props.argsMetadata],
        );

        const label = useMemo(() => {
            if (!props.argNames) return '';
            if (tree.length === 0) return 'No Args';
            return `Needs ${tree.length} arg${tree.length > 1 ? 's' : ''}`;
        }, [tree, props.argNames]);

        if (props.loading)
            return (
                <Skeleton variant="text" animation="wave" height="2em" width="10em" sx={{ ml: 'auto', mr: 'auto' }} />
            );

        return <TreeView tree={tree} label={label} />;
    },
);

ArgParams.displayName = 'ArgParams';
